/**
 * @fileoverview IntegrationsSettings - Combined settings for external integrations
 * Groups CFM API, SAP Integration, and API Keys into a single tab with sub-tabs
 */
import React from "react";
import { intl, DmsTabber, havePermissions } from "dmsbasereact";
import { Box, Typography } from "@mui/material";
import { CfmApiSettings } from "../CfmApiSettings/CfmApiSettings";
import { SAPIntegrationSettings } from "../SAPIntegrationSettings/SAPIntegrationSettings";
import { ApiKeyManagement } from "../ApiKeyManagement/ApiKeyManagement";
import { Permissions } from "../../constants/Permissions";

export const IntegrationsSettings = () => {
    // Build sub-tabs array based on user permissions
    const subTabs = [];

    // CFM API sub-tab
    if (havePermissions([Permissions.CAN_MANAGE_GENERAL_SETTINGS])) {
        subTabs.push({
            title: intl.get("CfmApi").d("CFM API"),
            component: <CfmApiSettings />
        });
    }

    // SAP Integration sub-tab
    if (havePermissions([Permissions.CAN_MANAGE_SAP_SETTINGS])) {
        subTabs.push({
            title: intl.get("SAPIntegration").d("SAP"),
            component: <SAPIntegrationSettings />
        });
    }

    // API Keys sub-tab
    if (havePermissions([Permissions.CAN_MANAGE_API_KEYS])) {
        subTabs.push({
            title: intl.get("APIKeys").d("API Keys"),
            component: <ApiKeyManagement />
        });
    }

    return (
        <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {intl.get("IntegrationsDescription").d(
                    "Configure external system integrations including CFM API for doctor validation, SAP for inventory management, and API keys for distributor access."
                )}
            </Typography>
            <DmsTabber tabs={subTabs} pageName={intl.get("Integrations").d("Integrations")} variant="scrollable" />
        </Box>
    );
};
